<footer class="footer" *transloco="let t">
  <div class="wrap top">
    <div class="brand">
      <a class="logo" aria-label="Ancelade" [routerLink]="localizedLink('/')">
        <img
          alt="Ancelade"
          width="140"
          height="38"
          loading="lazy"
          decoding="async"
          [src]="theme.isDark() ? '/logo/logo_dark.svg' : '/logo/logo_light.svg'"
        />
      </a>
      <p>{{ t('home2.footer.tagline') }}</p>
      <div class="socials">
        <a href="https://discord.gg/XmMr4nVusW" target="_blank" rel="noopener noreferrer" aria-label="Discord">
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path
              d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
            />
          </svg>
        </a>
      </div>
    </div>

    @for (column of columns; track column.key) {
      <nav class="column" [attr.aria-labelledby]="'footer2-' + column.key">
        <h2 [id]="'footer2-' + column.key">{{ t('home2.footer.columns.' + column.key) }}</h2>
        <ul>
          @for (link of column.links; track link.label) {
            <li>
              @if (link.path) {
                <a [routerLink]="localizedLink(link.path)" [queryParams]="link.queryParams">{{ t(link.label) }}</a>
              } @else {
                @let externalLabel = t(link.label);
                <a
                  [href]="link.href"
                  [attr.target]="link.external ? '_blank' : null"
                  [attr.rel]="link.external ? 'noopener noreferrer' : null"
                  >{{ externalLabel }}</a
                >
              }
            </li>
          }
        </ul>
      </nav>
    }

    <div class="alerts">
      <h2 id="footer2-alerts">{{ t('home2.footer.alerts.title') }}</h2>
      <p>{{ t('home2.footer.alerts.lead') }}</p>
      <form novalidate aria-labelledby="footer2-alerts" (submit)="subscribe($event, email)">
        <label class="sr-only" for="footer2-email">{{ t('statusPage.emailLabel') }}</label>
        <input
          #email
          id="footer2-email"
          name="email"
          type="email"
          autocomplete="email"
          required
          aria-describedby="footer2-alerts-message"
          [placeholder]="t('home2.footer.alerts.placeholder')"
          [attr.aria-invalid]="alertState() === 'invalid'"
        />
        <button
          type="submit"
          [disabled]="alertState() === 'sending'"
          [attr.aria-label]="t('home2.footer.alerts.submit')"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
            <path d="M5 12h14" />
            <path d="m12 5 7 7-7 7" />
          </svg>
        </button>
      </form>
      <p id="footer2-alerts-message" class="message" aria-live="polite" [attr.data-state]="alertState()">
        @if (alertState() === 'sent') {
          {{ t('statusPage.checkInbox') }}
        } @else if (alertState() === 'error') {
          {{ t('statusPage.subscribeError') }}
        } @else if (alertState() === 'invalid') {
          {{ t('home2.footer.alerts.invalid') }}
        }
      </p>
    </div>
  </div>

  <div class="wrap bottom">
    <span>© {{ year }} Ancelade. {{ t('home2.footer.rights') }}</span>
    <nav class="legal" [attr.aria-label]="t('home2.footer.legal')">
      <a [routerLink]="localizedLink('/mentions-legales')">{{ t('home.footer.legal') }}</a>
      <a [routerLink]="localizedLink('/cgu')">{{ t('footer.terms') }}</a>
      <a [routerLink]="localizedLink('/confidentialite')">{{ t('home.footer.privacy') }}</a>
    </nav>
    <div class="lang">
      <label class="sr-only" for="footer2-lang">{{ t('home2.footer.language') }}</label>
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Z" />
        <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
        <path d="M2 12h20" />
      </svg>
      <select #lang id="footer2-lang" (change)="switchLanguage(lang.value)">
        @for (option of language.languages; track option.code) {
          <option [value]="option.code" [selected]="option.code === language.currentLang()">{{ option.label }}</option>
        }
      </select>
    </div>
  </div>
  <p class="wrap note">{{ t('common.checkoutLanguage') }}</p>
</footer>
